export default __webpack_public_path__ + "static/cuemby-592107d26b31af6034382bc5bbb0ee0f.svg";